var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionCharactersQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionCharactersQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [NUM_CHARS_STAGE];
		}

		var numChars = answers[NUM_CHARS];
		if (numChars == "0") {
			return [NUM_CHARS_STAGE, true];
		}

		if (!answers[CHAR1_NAME]) {
			return [CHAR1_NAME_STAGE];
		}

		if (!answers[CHAR1_TRAIT]) {
			return [CHAR1_TRAIT_STAGE];
		} else if (this.props.level == "1" || (this.props.level == "2" && numChars == "1")) {
			return [CHAR1_TRAIT_STAGE, true];
		}

		if (this.props.level == "3" && !answers[CHAR1_GOAL]) {
			return [CHAR1_GOAL_STAGE];
		} else if (this.props.level == "3" && numChars == "1") {
			return [CHAR1_GOAL_STAGE, true];
		}

		if (!answers[CHAR2_NAME]) {
			return [CHAR2_NAME_STAGE];
		}
		if (!answers[CHAR2_REL]) {
			return [CHAR2_REL_STAGE];
		}
		if (!answers[CHAR2_TRAIT]) {
			return [CHAR2_TRAIT_STAGE];
		}

		return [CHAR2_TRAIT_STAGE, true];
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var numCharsDisplay = (
			<div>
				{ this.props.getTextF("label1", NUM_CHARS_STAGE) }
				{ this.props.renderDropdownF("choices1", NUM_CHARS_STAGE, NUM_CHARS, [NUM_CHARS]) }
				{ this.props.getTextF("label2", NUM_CHARS_STAGE) }.
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			var char1NameDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR1_NAME_STAGE) }
					{ this.props.renderInputF(CHAR1_NAME) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1) {
			var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;

			var char1TraitDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR1_TRAIT_STAGE, replacementsHash) }
					{ this.props.renderMultiSelectF("choices1", CHAR1_TRAIT_STAGE, CHAR1_TRAIT, 1) }
				</div>
			);
		}

		// goal is only for level 3
		if (_.indexOf(STAGES, stage) > 2 && this.props.level == "3") {
			var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;

			var char1GoalDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR1_GOAL_STAGE, replacementsHash) }
					{ this.props.renderDropdownF("choices1", CHAR1_GOAL_STAGE, CHAR1_GOAL) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 3) {
			var char2NameDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR2_NAME_STAGE) }
					{ this.props.renderInputF(CHAR2_NAME) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 4) {
			var char1Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR1_NAME];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.CHAR1_NAME] = char1Name;

			var char2RelDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR2_REL_STAGE, replacementsHash) }
					{ this.props.renderDropdownF("choices1", CHAR2_REL_STAGE, CHAR2_REL) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 5) {
			var char2Name = this.props.answers[FictionCharactersQuestion.STEM][CHAR2_NAME];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.CHAR2_NAME] = char2Name;

			var char2TraitDisplay = (
				<div>
					{ this.props.getTextF("label1", CHAR2_TRAIT_STAGE, replacementsHash) }
					{ this.props.renderMultiSelectF("choices1", CHAR2_TRAIT_STAGE, CHAR2_TRAIT, 1) }
				</div>
			);
		}

		return (
			<div>
				{ numCharsDisplay }
				{ char1NameDisplay }
				{ char1TraitDisplay }
				{ char1GoalDisplay }
				{ char2NameDisplay }
				{ char2RelDisplay }
				{ char2TraitDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionCharactersQuestion.STEM = "fchar";

// stages
var NUM_CHARS_STAGE = "numchars";
var CHAR1_NAME_STAGE = "char1name";
var CHAR1_TRAIT_STAGE = "char1trait";
var CHAR1_GOAL_STAGE = "char1goal";
var CHAR2_NAME_STAGE = "char2name";
var CHAR2_REL_STAGE = "char2rel";
var CHAR2_TRAIT_STAGE = "char2trait";

var STAGES = [
	NUM_CHARS_STAGE, CHAR1_NAME_STAGE, CHAR1_TRAIT_STAGE, CHAR1_GOAL_STAGE, CHAR2_NAME_STAGE,
	CHAR2_REL_STAGE, CHAR2_TRAIT_STAGE
];

// answer keys
var NUM_CHARS = "num_characters";
var CHAR1_NAME = "character_1_name";
var CHAR1_TRAIT = "character_1_trait";
var CHAR1_GOAL = "character_1_goal";
var CHAR2_NAME = "character_2_name";
var CHAR2_REL = "character_2_relation";
var CHAR2_TRAIT = "character_2_trait";

FictionCharactersQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderMultiSelectF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionCharactersQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionCharactersQuestion.js